import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { EFEITO_LABELS, NATUREZA_LABELS } from '@/lib/deadlines'
import { formatDateBr } from '@/lib/publication-inbox'
import type { Suspension, SuspensionInput } from '@/services/deadline-service'
import { SuspensionForm } from './SuspensionForm'

interface Props {
  tribunal: string
  suspensions: Suspension[]
  canEdit: boolean
  onCreate: (input: SuspensionInput) => Promise<boolean>
  onCancel: (s: Suspension) => void
}

/** Suspensões e feriados cadastrados pelo sócio (entram no cálculo do tribunal ou da UF). */
export function SuspensionsPanel({ tribunal, suspensions, canEdit, onCreate, onCancel }: Props) {
  return (
    <div className="space-y-4">
      {canEdit && tribunal && <SuspensionForm tribunal={tribunal} onSubmit={onCreate} />}
      {canEdit && !tribunal && <p className="text-sm text-muted-foreground">Escolha um tribunal para cadastrar.</p>}
      {suspensions.length === 0 ? (
        <p className="text-sm text-muted-foreground">Nenhuma suspensão cadastrada.</p>
      ) : (
        <ul className="divide-y rounded-lg border" aria-label="Suspensões cadastradas">
          {suspensions.map((s) => (
            <li key={s.id} className="flex flex-wrap items-center justify-between gap-2 p-3 text-sm">
              <div>
                <p className="font-medium">
                  {formatDateBr(s.dataInicio)}{s.dataFim !== s.dataInicio ? ` a ${formatDateBr(s.dataFim)}` : ''} — {s.motivo}
                </p>
                <div className="mt-1 flex flex-wrap gap-1">
                  <Badge variant="secondary">{s.tribunal}{s.uf ? ` · ${s.uf}` : ''}</Badge>
                  <Badge variant="outline">{NATUREZA_LABELS[s.natureza]}</Badge>
                  <Badge variant="outline">{EFEITO_LABELS[s.efeito]}</Badge>
                  {s.fonteUrl && <a href={s.fonteUrl} target="_blank" rel="noreferrer noopener" className="text-xs underline">fonte</a>}
                </div>
              </div>
              {canEdit && <Button size="sm" variant="ghost" onClick={() => onCancel(s)}>Cancelar</Button>}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
